import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV ?? 'development',
  release: import.meta.env.VITE_RELEASE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: import.meta.env.VITE_ENV === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  enabled: import.meta.env.VITE_ENV !== 'development',
  beforeSend(event) {
    const raw = event.breadcrumbs?.values;
    const crumbs =
      typeof raw === 'function' ? [...raw()] : Array.isArray(raw) ? raw : [];
    for (const crumb of crumbs) {
      if (crumb.data?.['Authorization']) delete crumb.data['Authorization'];
    }
    return event;
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
